// Services
import PrestadoresService from "./PrestadoresService";
import AnalistaService from "@/shared/services/AnalistaService";
import UnimedService from "@/shared/services/UnimedService";

// Mixin padrão para a tabela
import TabelaMixin from "@/shared/mixin/TabelaMixin";

import ListagemPrestadoresMock from "../../../shared/Mocks/ListagemPrestadores/ListagemPrestadoresMock.json";
import {
  enumStatusPrestador,
  enumStatusPrestadorNome,
  EnumPerfis
} from "../../../shared/helpers/Enum";

export default {
  name: "prestadores",
  mixins: [PrestadoresService, AnalistaService, TabelaMixin, UnimedService],
  data() {
    return {
      listaAnalistas: [],
      listaStatus: [],
      listaTipoAtendeIntercambio: [],
      listaUnimedOrigem: [],
      listaTipos: [],
      listaRedes: [],
      listaTipoAtuacao: [],
      ListagemPrestadoresMock,
      limparUnimed: false,
      campoPesquisa: "",
      objetoFiltroLocal: {},
      visualizaNaoOperadoras: false,
      cabecalho: [
        {
          texto: "Código",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "70px"
          },
          campoOrdenacao: "codigo"
        },
        {
          texto: "Nome",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "245px"
          },
          campoOrdenacao: "nome"
        },
        {
          texto: "Tipo",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "60px"
          },
          campoOrdenacao: "tipoDescricao"
        },
        {
          texto: "CPF/CNPJ",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "130px"
          },
          campoOrdenacao: "cpfCnpj"
        },
        {
          texto: "Rede",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "60px"
          },
          campoOrdenacao: "tipoRede"
        },
        {
          texto: "Unimed origem",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "cdUnimed"
        },
        {
          texto: "Status",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "100px"
          },
          campoOrdenacao: "ordemStatus"
        }
      ],
      cabecalhoIntercambio: [
        {
          texto: "Código",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "70px"
          },
          campoOrdenacao: "codigo"
        },
        {
          texto: "Nome",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "245px"
          },
          campoOrdenacao: "nome"
        },
        {
          texto: "Tipo",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "60px"
          },
          campoOrdenacao: "tipoDescricao"
        },
        {
          texto: "CPF/CNPJ",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "130px"
          },
          campoOrdenacao: "cpfCnpj"
        },
        {
          texto: "Rede",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "60px"
          },
          campoOrdenacao: "tipoRede"
        },
        {
          texto: "Unimed origem",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "cdUnimed"
        },
        {
          texto: "Status",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "100px"
          },
          campoOrdenacao: "ordemStatus"
        },
        {
          texto: "Intercâmbio",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "20px"
          },
          campoOrdenacao: "atendeIntercambio"
        }
      ]
    };
  },
  beforeMount() {
    this.init();
    this.habilitarIntercambio();
  },
  methods: {
    /**
     * Método inicial da página
     */
    init() {
      this.loadingTabela = true;
      this.visualizaNaoOperadoras =
        this.papelUsuarioMixin.chave === EnumPerfis.ADMINISTRADOR ||
        this.papelUsuarioMixin.chave === EnumPerfis.GTR;
      this.inicializarAnalistas().finally(() => {
        this.inicializarRedes().finally(() => {
          this.inicializarStatus().finally(() => {
            this.inicializarAtendimentoIntercambio().finally(() => {
              this.inicializarTipos().finally(() => {
                this.inicializarUnimeds().finally(() => {
                  this.inicializarTipoAtuacao().finally(() => {
                    this.inicializarOrdenacaoPadrao();
                    this.inicializarFiltroPadrao();
                  });
                });
              });
            });
          });
        });
      });
    },
    /**
     * Método que faz a chamada na service para recuperar as linhas da tabela e outras informações adicionais
     */
    iniciarTabela() {
      this.loadingTabela = true;
      let tempObjetoTabela = this.objetoTabelaAtual();

      this.getTabelaPrestadores(tempObjetoTabela)
        .then(res => {
          console.log(res.data);
          this.configurarTabela(res.data, rows => {
            if (this.habilitarFiltroIntercambio) {
              this.montarTabelaComIntercambio(rows);
            } else {
              this.montarTabela(rows);
            }
          });
        })
        .finally(() => {
          this.loadingTabela = false;
          this.iniciado = true;
        });
    },
    /**
     * Método para montar a tabela
     *  @param {Array} rows - linhas da tabela
     */
    montarTabela(rows) {
      this.rows = [];
      rows.forEach(e => {
        const {
          id,
          unimedOrigem,
          cpfCnpj,
          codigo,
          nome,
          tipo: { descricao: descricaoTipo },
          rede: { descricao: descricaoRede },
          status: { chave: statusChave, descricao: descricaoChave },
          // atendeIntercambioAnterior,
          // atendeIntercambio,
          dtExclusaoProgramada,
          dtEnvioExclusao
          // dtIntercambioVirouNao
        } = e;

        let objetoStatusTemp = enumStatusPrestador[statusChave];
        objetoStatusTemp.textoEstilo = descricaoChave;

        if (statusChave === enumStatusPrestadorNome.EXCLUSAO_PROGRAMADA) {
          objetoStatusTemp.textoEstilo = "Ativo";
          objetoStatusTemp.icones[0].tooltip = `Exclusão programada para ${this.$helpers.formatadorDataSafe(
            dtExclusaoProgramada,
            "L"
          )}`;
        }

        if (statusChave === enumStatusPrestadorNome.EXCLUIDO) {
          objetoStatusTemp.textoEstilo = "Excluido";
          objetoStatusTemp.texto = `Exclusão enviada em: ${this.$helpers.formatadorDataSafe(
            dtEnvioExclusao,
            '"Sem Data"'
          )}`;
          delete objetoStatusTemp.icones;
        }

        this.rows.push({
          codigo,
          nome: {
            texto: nome || " - ",
            qtdMaxCaracteres: 30,
            whiteSpaceNoWrap: false,
            larguraMaxima: 900,
            tooltipLocalizacao: "top"
          },
          tipo: descricaoTipo,
          // tooltipStatus: "teste",
          documento: cpfCnpj,
          rede: descricaoRede,
          unimedOrigem,
          status: objetoStatusTemp,
          naoMostrar: {
            naoAparece: true,
            id
          }
        });
      });
      this.salvarFiltro();
    },

    montarTabelaComIntercambio(rows) {
      this.rows = [];
      rows.forEach(e => {
        const {
          id,
          unimedOrigem,
          cpfCnpj,
          codigo,
          nome,
          tipo: { descricao: descricaoTipo },
          rede: { descricao: descricaoRede },
          status: { chave: statusChave, descricao: descricaoChave },
          atendeIntercambio,
          dtExclusaoProgramada,
          dtIntercambioVirouNao,
          intercambioVirouNao,
          dtEnvioExclusao
        } = e;

        let objetoStatusTemp = enumStatusPrestador[statusChave];
        objetoStatusTemp.textoEstilo = descricaoChave;

        if (statusChave === enumStatusPrestadorNome.EXCLUSAO_PROGRAMADA) {
          objetoStatusTemp.textoEstilo = "Ativo";
          objetoStatusTemp.icones[0].tooltip = `Exclusão programada para ${this.$helpers.formatadorDataSafe(
            dtExclusaoProgramada,
            "L"
          )}`;
        }

        if (statusChave === enumStatusPrestadorNome.EXCLUIDO) {
          objetoStatusTemp.textoEstilo = "Excluido";
          objetoStatusTemp.texto = `Exclusão enviada em: ${this.$helpers.formatadorDataSafe(
            dtEnvioExclusao,
            '"Sem Data"'
          )}`;
          delete objetoStatusTemp.icones;
        }

        this.rows.push({
          codigo,
          nome: {
            texto: nome || " - ",
            qtdMaxCaracteres: 30,
            whiteSpaceNoWrap: false,
            larguraMaxima: 900,
            tooltipLocalizacao: "top"
          },
          tipo: descricaoTipo,
          documento: cpfCnpj,
          rede: descricaoRede,
          unimedOrigem,
          status: objetoStatusTemp,

          atendeIntercambioAnterior:
            atendeIntercambio.chave === "SIM"
              ? "Sim"
              : intercambioVirouNao
              ? {
                  icones: [
                    {
                      icone: "alert-triangle",
                      tamanho: 20,
                      feather: true,
                      tooltip: `ID_INTERCAMBIO alterado para N em ${this.$helpers.formatadorDataSafe(
                        dtIntercambioVirouNao,
                        "L"
                      )}`,
                      direcaoEsquerda: true,
                      style: {
                        color: "#ED1651"
                      }
                    }
                  ]
                }
              : atendeIntercambio.chave === "SIM"
              ? "Sim"
              : "Não",
          naoMostrar: {
            naoAparece: true,
            id
          }
        });
      });
      this.salvarFiltro();
    },

    /**
     * Limpa o objeto da pesquisa
     */
    limparPesquisa() {
      this.campoPesquisa = "";
    },
    /**
     * Método pra fazer a chamada para unimedOrigem vazia, logo após limpar o campo de pesquisa
     */
    limparCampoPesquisa() {
      this.limparPesquisa();
    },
    /**
     * Método que é chamado logo após feito o clique em uma das linhas
     * @param {Number} index - linha que foi feito o clique
     */
    clickLinha(index) {
      const { id } = this.rows[index].naoMostrar;
      if ([null, undefined, ""].includes(id)) return;
      this.$router.push(this.$options.name + "/" + id);
    },

    pesquisarTabela() {
      this.$set(this.objetoTabela, "pagina", this.pagina);
      this.$set(this.objetoTabela, "busca", this.campoPesquisa);
      this.filtrar();
    },

    inicializarOrdenacaoPadrao() {
      this.objetoTabela.ordenacao = "ordemStatus";
      this.objetoTabela.direcao = "ASC";
    },

    inicializarFiltroPadrao() {
      const { chave } = this.papelUsuarioMixin;

      if (chave === EnumPerfis.SINGULAR) {
        const refFiltro = this.$refs["filtro"];

        refFiltro.setFiltro({
          ...refFiltro.objetoFiltroVazio,
          unimedOrigem: {
            chave: "",
            descricao:
              this.codigoUnimedUsuarioMixin +
              " - " +
              this.unimedSelecionadaNomeMixin
          }
        });

        this.$nextTick(() => {
          refFiltro.filtrar();
        });
        return;
      }

      this.iniciarTabela();
    },

    inicializarAnalistas() {
      return new Promise((resolve, reject) => {
        this.getAnalistas()
          .then(res => {
            this.listaAnalistas = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarRedes() {
      return new Promise((resolve, reject) => {
        this.getRedes()
          .then(res => {
            this.listaRedes = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarStatus() {
      return new Promise((resolve, reject) => {
        this.getStatus(this.visualizaNaoOperadoras)
          .then(res => {
            this.listaStatus = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarAtendimentoIntercambio() {
      return new Promise((resolve, reject) => {
        this.getAtendimentoIntercambio()
          .then(res => {
            this.listaTipoAtendeIntercambio = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarTipos() {
      return new Promise((resolve, reject) => {
        this.getTipos()
          .then(res => {
            this.listaTipos = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarUnimeds() {
      return new Promise((resolve, reject) => {
        this.getAllUnimeds()
          .then(res => {
            this.listaUnimedOrigem = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarTipoAtuacao() {
      return new Promise((resolve, reject) => {
        this.getTipoAtucao(this.visualizaNaoOperadoras)
          .then(res => {
            this.listaTipoAtuacao = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },

    habilitarIntercambio() {
      if (this.habilitarFiltroIntercambio) {
        this.cabecalho.push({
          texto: "Intercâmbio",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "20px"
          },
          campoOrdenacao: "atendeIntercambio"
        });
      }
    }
  },
  props: {
    habilitarFiltroIntercambio: {
      type: Boolean,
      default: false
    }
  }
};
